import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=41982d3b&"
import script from "./SettingsPage.vue?vue&type=script&lang=js&"
export * from "./SettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports